import { render, staticRenderFns } from "./DealRejectedModal.vue?vue&type=template&id=358bbe50"
import script from "./DealRejectedModal.vue?vue&type=script&lang=js"
export * from "./DealRejectedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports